import { message } from 'antd'
import DocumentsApi from '../../../api/Documents'
import Email from '../../../api/Email'
import { OrdersApi } from '../../../api/Purchase/Orders'
import Templates from '../../../api/Templates'
import UpdateOrder from '../../../components/Purchasing/Order/UpdateOrder'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useFetchObject from '../../../elements/Hooks/useFetchObject'
import useModalShow from '../../../elements/Hooks/useModalShow'
import useSubmit from '../../../elements/Hooks/useSubmit'
import { get, isEmpty, pick } from 'lodash'
import React, { useState } from 'react'

const docsApi = new DocumentsApi()
const templateApi = new Templates()
const emailApi = new Email()

function UpdateOrderCont(props) {
  const key = get(props.match, 'params.key')
  const isNew = !key

  const { fetch: fetchOrder, fetching, object: order, setObject: setOrder } = useFetchObject(
    () => OrdersApi.get(key),
    false,
    [key],
    isEmpty(key)
  )

  let { list: lines, fetching: fetchingLines, fetch: fetchLines } = useFetchList(() => OrdersApi.getLinesByOrder(key))

  function fetch() {
    fetchOrder()
    fetchLines()
  }

  const formRef = React.createRef()
  const [updating, updateFunc] = useSubmit(OrdersApi.update)

  const [removing, removeFunc] = useSubmit(OrdersApi.remove)

  async function remove() {
    const removed = await removeFunc({
      ...pick(order, ['_key', '_rev', '_id']),
    })
    if (removed)
      props.history.replace({
        pathname: `/purchasing/order/`,
      })
  }

  function checkForm() {
    return new Promise((res, rej) => {
      formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(values)
        } else rej(err)
      })
    })
  }

  async function update() {
    const values = await checkForm()
    const orderDB = await updateFunc({
      ...pick(order, ['_key', '_id', '_rev']),
      ...values,
    })
    if (orderDB) setOrder(orderDB)
  }

  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('purchases', order.status),
    [order.status, isEmpty(order.status)]
  )

  const [submittingOperation, submitOperation] = useSubmit(OrdersApi.operation)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    const doc = await submitOperation({
      status: operation,
      ...pick(order, ['_key', '_rev', '_id']),
    })
    if (doc) {
      setOrder(doc)
    }
    fetch()
    hide()
  }

  const [submittingTemplate, submitTemplate] = useSubmit(templateApi.read, true)
  const [submittingOrderTemplate, submitOrderTemplate] = useSubmit(emailApi.orderTemplate, true)
  const [submittingOrderFiles, submitOrderFiles] = useSubmit(OrdersApi.files, true)
  const [emailTemplate, setEmailTemplate] = useState('')
  const [emailDetails, setEmailDetails] = useState('')
  const [emailFiles, setEmailFiles] = useState([])
  const [emailLines, setEmailLines] = useState([])

  const { visible: visibleEmail, onShow: onShowEmail, onCancel: onCancelEmail } = useModalShow(async () => {
    let emailLines = lines.map((l) => ({
      _id: l._id,
      _key: l._key,
      no: l.no,
      name: l.name,
      unit: l.unit,
      rate: l.rate,
      uom: l.uom.code,
      total: l.amount.net,
    }))

    emailLines.sort((a, b) => a.no - b.no)
    console.log('emailLines', emailLines, lines)



    const company = get(order, 'company._id', '').replace('members/', '')
    const orderTemplate = await submitTemplate(company, 'purchase')
    //const orderTemplate = await submitTemplate('order', 'order')
    const emailDetails = get(orderTemplate, 'email') || {}
    const data = await submitOrderTemplate({
      receiver: get(order, 'vendorRep.fn'),
      companyRep: get(order, 'companyRep.fn'),
      code: get(order, 'code'),
      quoteNo: get(order, 'vendorQuote.quoteNo'),
      currency: get(order, 'currency'),
      lines: emailLines,
      ...emailDetails,
    })

    const filesList = await submitOrderFiles([order._id])
    setEmailFiles(filesList)
    const filesMapped = filesList.map((f) => f.uuid)
    const to = get(order, 'vendorRep.email.label')
    setEmailTemplate(data.html)
    setEmailDetails({
      to: to,
      bcc: get(emailDetails, 'bcc'),
      cc: get(order, 'companyRep.email.label'),
      from: get(emailDetails, 'from'),
      subject: `[${get(order, 'code')}] ${get(emailDetails, 'subject')}`,
      attachments: filesMapped,
    })
    setEmailLines([order])
  })

  const isUpdatable = isNew ? true : actions.find((a) => a.key === 'update')

  const [collecting, collectFunc] = useSubmit(OrdersApi.massCollect)

  async function massCollect() {
    console.log('massCollect')
    const db = await collectFunc({
      ...pick(order, ['_key', '_id', '_rev']),
    })
    fetch()
  }

  return (
    <UpdateOrder
      {...{
        lines,
        key,
        order,
        fetching,
        fetch,
        updating,
        update,
        removing,
        remove,
        formRef,
        actions,
        handleActions,
        massCollect,
        fetchingActions,
        onShowEmail,
        visibleEmail,
        onCancelEmail,
        emailTemplate,
        emailDetails,
        emailFiles,
        emailLines,
        isUpdatable,
        isNew,
      }}
    />
  )
}

export default UpdateOrderCont
